// Centralised image asset map — Asia Sourcing original photography.
// All shots are from partner workshops across India (2024-2025).

const BASE = "https://customer-assets.emergentagent.com/job_india-sourcing-hub-2/artifacts";

export const IMG = {
  blockPrint: `${BASE}/elm86mkp_210CB9A9-2E47-4A20-AB35-A1FC58714566.png`, // textile · block printing
  carpet: `${BASE}/gqduxjol_726E87B1-EBA3-468C-A80D-10361D4B5515.png`,     // textile · carpet hand-finishing
  brassLathe: `${BASE}/hz98lfmc_B85AC5D2-0E01-448A-BFEE-C4E8E687E4D3.png`,  // brass · lathe / workshop
  pottery: `${BASE}/4vshlb6w_2488C0C8-9F5F-49CB-B89B-957A4819DF61.png`,    // ceramic · pottery wheel
  woodwork: `${BASE}/b844eelb_9C323BD6-C46B-4B29-8703-06684A96BCD0.png`,   // furniture · woodworking
  brassCast: `${BASE}/zzgyqzwg_FF7EE322-FEAC-41FD-B430-6BB7D8D566BC.png`,  // brass · casting / molten metal
  brassSpin: `${BASE}/9kz3zlcu_4040B386-57D4-4009-9540-02894FD03167.png`,  // brass · pendant spinning lathe
  glassBlowing: `${BASE}/zrja1grd_58C9B5C2-8860-492D-9420-5CE424B83120.png`, // glass · Firozabad blowing floor
  founder: `${BASE}/sbd4jl3r_C4A6F461-C249-4688-B315-1E02F568935D.png`,     // Dr. Sumit Chhabra portrait
  lightingProduct: `${BASE}/198wyawf_IMG_0955.jpeg`,                        // lighting · finished pendants display
  furnitureProduct: `${BASE}/20e6rqo4_F50559EF-7C15-4181-B116-EF999534EB5A.png`, // furniture · carved wood showroom
  textileProduct: `${BASE}/ke1tjwv7_751CB0D0-3519-43CA-9552-86751A45263F.png`,   // textile · indigo block-print display
  decorProduct: `${BASE}/xu2xk2cz_988D7A5B-F1F2-4D28-B07C-5BED7079D975.png`,    // décor · tufted rugs & tapestries
  // Fashion accessories
  leatherBag: `${BASE}/nhe5d2af_IMG_0963.jpeg`,                             // sculptural leather fan-bag
  silverCuffs: `${BASE}/4lchzsso_IMG_0964.jpeg`,                            // engraved silver cuffs / bangles
  mosaicClutch: `${BASE}/spscupn3_IMG_0965.jpeg`,                           // inlaid mosaic-stone clutch
  embroideredApparel: `${BASE}/iep4h05f_75504079-3A05-4DB8-BC4D-1B7F84EBDF5E.png`, // embroidered kaftan / abaya
  polkiJewellery: `${BASE}/7g6k693j_533604A4-F3C4-4595-8192-0C84FBD22D72.png`,     // polki / kundan jewellery set
  fashionWorkshop: `${BASE}/e7ap6mdw_IMG_0961.jpeg`,                        // fashion workshop / atelier
  logo: `/brand/asia-sourcing-logo.png`,                                    // Official Asia Sourcing India brand logo (Feb 2026)
};

export default IMG;
